<template>
	<div id="page-404" class="column-center" style="width: 100vw;height: 100vh;">
		<img src="../assets/img/404.png" alt="">
		<router-link to="/" class="row-center back" tag="div">返回首页</router-link>
	</div>
</template>

<script>
	export default {
		name: "404"
	}
</script>

<style scoped>
.back {
	font-size: 16px;
	background-color: #0d94ff;
	border-radius: 6px;
	color: #FFFFFF;
	width: 100px;
	height: 40px;
	line-height: 100%;
	margin-top: 20px;
	cursor: pointer;
}
</style>